import { getEnvironmentApiUrls } from '@dvag/dfs-constant-config/api-urls';

import { Appointment, Booking, Feedback, FeedbackRequestBody } from 'type/advisor';
import { AppointmentPayload } from 'type/appointment';
import { normalizeFeedback, normalizeFeedbackRequest } from 'service/model/feedbackUtil';
import { versions } from './versions';
import { getApiClient } from './api-client';

export const appointmentApi = () => {
  const baseURL = `${getEnvironmentApiUrls().appointment}/${versions.v2}`;

  const api = getApiClient(baseURL);

  const getBooking = async () => api.get<Booking>(`/booking`);

  const getAppointment = async ({ householdId, type }: { householdId: string; type: string }) =>
    api.get<Appointment[]>(`/appointment?householdId=${householdId}&status=OPEN&type=${type}`);

  const postAppointment = async (requestBody: AppointmentPayload) =>
    api.post<Appointment, AppointmentPayload>(`appointment`, requestBody);

  const patchAppointment = async ({
    id,
    householdId,
    personId,
    startDateTime,
    type,
  }: AppointmentPayload) =>
    api.patch<Appointment, Omit<AppointmentPayload, 'id' | 'date' | 'time'>>(`appointment/${id}`, {
      householdId,
      personId,
      startDateTime,
      type,
    });

  const getFeedback = async ({
    appointmentId,
    householdId,
  }: {
    appointmentId?: string;
    householdId?: string;
  }) => {
    const response = await api.get<Feedback>(
      `/feedback?appointmentId=${appointmentId}&householdId=${householdId}`,
    );

    return {
      ...response,
      data: response.data ? normalizeFeedback(response.data) : response.data,
    };
  };

  const patchFeedback = async ({ id, ...params }: FeedbackRequestBody) => {
    const response = await api.patch<Feedback, FeedbackRequestBody>(
      `/feedback/${id}`,
      normalizeFeedbackRequest(params),
    );

    return {
      ...response,
      data: response.data ? normalizeFeedback(response.data) : response.data,
    };
  };

  const postFeedback = async (requestBody: FeedbackRequestBody) => {
    const response = await api.post<Feedback, FeedbackRequestBody>(
      `/feedback`,
      normalizeFeedbackRequest(requestBody),
    );

    return {
      ...response,
      data: response.data ? normalizeFeedback(response.data) : response.data,
    };
  };

  return {
    getBooking,
    getAppointment,
    getFeedback,
    patchFeedback,
    postFeedback,
    postAppointment,
    patchAppointment,
  };
};
